module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intern-notes-container text-dark"
  }, [_c('button', {
    staticClass: "open-button",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.ongoing_absence')) + "\n    "), (_vm.absenceAutogeneratedToday > 0) ? _c('div', {
    staticClass: "dot--for-autogenered hint--bottom",
    attrs: {
      "aria-label": _vm.textAbsenceCreatedAuto
    }
  }, [_vm._v("\n      " + _vm._s(_vm.absenceAutogeneratedToday) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideInRight"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "subs-note",
    class: {
      'subs-note--is-open': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "subs-note__container"
  }, [_c('div', {
    staticClass: "subs-note__container__header"
  }, [_c('div', {
    staticClass: "subs-note__container__header__close icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.teachers_with_ongoing_absence')))])]), _vm._v(" "), _c('div', {
    staticClass: "subs-note__container__body"
  }, [(_vm.absentUsersSorted.length < 1) ? _c('h4', {
    staticClass: "text-explainer"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.no_teachers_with_ongoing_absence')))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.absentUsersSorted), function(user) {
    return _c('li', {
      staticClass: "absent-user shadow"
    }, [_c('div', {
      staticClass: "absent-user__badges right marg-5-left"
    }, [(_vm.getIsUserAbsenceAutogeneratedToday(user)) ? _c('div', {
      staticClass: " badge badge--small badge--orange"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.auto_created')) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "absent-user__name"
    }, [_c('img', {
      attrs: {
        "src": user.default_thumb_url
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(user && user.name ? user.name : ''))])]), _vm._v(" "), _c('ul', _vm._l((user.reasons), function(reason) {
      return _c('li', [_c('h4', [_vm._v(_vm._s(_vm.getReasonTitle(reason)))]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "icon-calendar4"
      }), _vm._v(" " + _vm._s(_vm._f("date")(reason.from_date)) + " -\n                    " + _vm._s(_vm._f("date")(reason.to_date)) + "\n                  ")]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "icon-clock"
      }), _vm._v(" " + _vm._s(_vm._f("showTime")(reason.from_time)) + " -\n                    " + _vm._s(_vm._f("showTime")(reason.to_time)) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "actions"
      }, [_c('button', {
        staticClass: "bttn bttn-primary shadow",
        on: {
          "click": function($event) {
            return _vm.setTheEditAbsenceReason(reason)
          }
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.$t('vue2.subs_ongoing_absence.edit_stop')) + "\n                    ")])])])
    }), 0)])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        _vm.isOpen = false
      }
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31bbfc94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsAbsentWithoutEnd.vue
// module id = 1536
// module chunks = 1